import { render, staticRenderFns } from "./Profile.version.1.vue?vue&type=template&id=77d35220&"
import script from "./Profile.version.1.vue?vue&type=script&lang=js&"
export * from "./Profile.version.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports